export const environment = {
	Production: true,
	WebServiceUrl: "https://connect.crowndatasystems.com/api/",
	ReportsUrl: "https://connect.crowndatasystems.com/Reports/",
	VerboseLogging: false,
	EnableGoogleAnalytics: true,
	GoogleAnalyticsUAID: "G-XPE3SNLWHS",
	Version: "7.88",
	BasicAuthUserName: "CrownConnectWebService",
	BasicAuthPassword: "rkR+$NEZANz)5NGu"
};
